import { isObjectEmpty } from '../../common/utils/productCardProps';
export const validateFastTrackAvailabilityTranslation = availabilityProps => {
  try {
    if (isObjectEmpty(availabilityProps)) {
      return false;
    }
    const {
      availabilityCard,
      cart
    } = availabilityProps;
    if (isObjectEmpty(availabilityCard) || isObjectEmpty(cart)) {
      return false;
    }
    const {
      availabilityTitle,
      departing,
      return: returnKey,
      availableStatus,
      unavailableStatus,
      addedStatus,
      statusTooltip,
      addedTitle
    } = availabilityCard;
    const {
      purchasedMessage
    } = cart;
    return Boolean(availabilityTitle && departing && returnKey && availableStatus && unavailableStatus && addedStatus && statusTooltip && addedTitle && purchasedMessage);
  } catch (error) {
    return false;
  }
};
//# sourceMappingURL=utils.js.map